<template>
  <div v-if="errors.length > 0">
    <notice
      v-for="error in errors"
      :key="error"
      :type="'failure'"
      :message="error"
    />
  </div>
</template>
<script>
import Notice from './tdesk_notice';

export default {
  components: { Notice },
  props: {
    errors: { type: Array, required: true },
  },
};
</script>
